if (window.__POWERED_BY_QIANKUN__) {
  var __webpack_public_path__;
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}
